<template>
  <b-card no-body>
    <b-card-header class="d-flex justify-content-between align-items-center flex-wrap">
      <div>
        <b-card-title class="mb-0">
          네이버테마
        </b-card-title>
        <small class="text-muted">{{ sourceUrl }}</small>
      </div>
      <b-button
        variant="primary"
        :disabled="loading"
        @click="fetchThemes"
      >
        <b-spinner
          v-if="loading"
          small
          class="mr-50"
        />
        새로고침
      </b-button>
    </b-card-header>

    <b-card-body>
      <b-alert
        v-if="errorMessage"
        variant="danger"
        show
      >
        {{ errorMessage }}
      </b-alert>

      <b-table
        :items="items"
        :fields="fields"
        responsive
        small
        show-empty
        empty-text="조회된 네이버 테마가 없습니다."
        :busy="loading"
      >
        <template #cell(themeName)="row">
          <a
            v-if="row.item.detailUrl"
            :href="row.item.detailUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ row.item.themeName }}
          </a>
          <span v-else>{{ row.item.themeName }}</span>
        </template>
        <template #cell(changeRate)="row">
          <span :class="rateClass(row.item.changeRate)">{{ row.item.changeRate }}</span>
        </template>
        <template #cell(recent3daysChangeRate)="row">
          <span :class="rateClass(row.item.recent3daysChangeRate)">{{ row.item.recent3daysChangeRate }}</span>
        </template>
        <template #cell(leaders)="row">
          <div class="d-flex flex-column">
            <a
              v-if="row.item.leaderStock1"
              :href="row.item.leaderStock1Url"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ row.item.leaderStock1 }}
            </a>
            <a
              v-if="row.item.leaderStock2"
              :href="row.item.leaderStock2Url"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ row.item.leaderStock2 }}
            </a>
          </div>
        </template>
      </b-table>
    </b-card-body>
  </b-card>
</template>

<script>
import axios from '@axios'
import {
  BAlert,
  BButton,
  BCard,
  BCardBody,
  BCardHeader,
  BCardTitle,
  BSpinner,
  BTable,
} from 'bootstrap-vue'

export default {
  components: {
    BAlert,
    BButton,
    BCard,
    BCardBody,
    BCardHeader,
    BCardTitle,
    BSpinner,
    BTable,
  },
  data() {
    return {
      loading: false,
      errorMessage: '',
      sourceUrl: 'https://finance.naver.com/sise/theme.naver?&page=1',
      items: [],
      fields: [
        { key: 'themeName', label: '테마명' },
        { key: 'changeRate', label: '전일대비' },
        { key: 'recent3daysChangeRate', label: '최근3일 등락률(평균)' },
        { key: 'riseCount', label: '상승' },
        { key: 'steadyCount', label: '보합' },
        { key: 'fallCount', label: '하락' },
        { key: 'leaders', label: '주도주' },
      ],
    }
  },
  created() {
    this.fetchThemes()
  },
  methods: {
    parseApiResponse(response) {
      const payload = response && response.data ? response.data : null
      if (!payload || payload.success !== true) {
        throw new Error(payload && payload.error ? payload.error : '요청 처리 중 오류가 발생했습니다.')
      }
      return payload.data
    },
    async fetchThemes() {
      this.loading = true
      this.errorMessage = ''
      try {
        const response = await axios.get('/api/kiwoom/naver-theme/list')
        const data = this.parseApiResponse(response)
        this.sourceUrl = data.sourceUrl || this.sourceUrl
        this.items = Array.isArray(data.items) ? data.items : []
      } catch (error) {
        this.items = []
        this.errorMessage = error && error.message ? error.message : '네이버 테마 조회에 실패했습니다.'
      } finally {
        this.loading = false
      }
    },
    rateClass(value) {
      const text = String(value || '').trim()
      if (text.startsWith('+')) return 'text-danger'
      if (text.startsWith('-')) return 'text-primary'
      return 'text-body'
    },
  },
}
</script>
